/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Stack, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import {
  formatHeroLenteResumo,
  formatMedicaoPeriodLabel,
  getPrimeiroNome,
} from './constants';

const HeroStrip = ({
  authData,
  inicio,
  fim,
  lentes,
  heroResumos,
  loading,
  onExport,
}) => {
  const primeiroNome = getPrimeiroNome(authData?.nome);
  const periodoLabel = formatMedicaoPeriodLabel(inicio, fim);

  const resumoLines = (lentes || [])
    .map((lente) => {
      const resumo = heroResumos?.[lente.id];
      const texto = formatHeroLenteResumo(resumo, lente);
      if (!texto) return null;
      return `${lente.label} ${texto}`;
    })
    .filter(Boolean);

  return (
    <Stack spacing={2} sx={{ pr: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={1}
      >
        <Box>
          <Typography variant="h4">Minha digitação</Typography>
          {primeiroNome && (
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              Olá, {primeiroNome}
            </Typography>
          )}
        </Box>
        {onExport && (
          <Button
            variant="contained"
            startIcon={<DescriptionOutlinedIcon />}
            onClick={onExport}
          >
            Exportar
          </Button>
        )}
      </Stack>

      {periodoLabel && (
        <Typography variant="body2" color="text.secondary">
          {loading && !resumoLines.length
            ? `Período de medição ${periodoLabel} · carregando…`
            : resumoLines.length
              ? `Período de medição ${periodoLabel} · ${resumoLines.join(' · ')}`
              : `Período de medição ${periodoLabel}`}
        </Typography>
      )}
    </Stack>
  );
};

HeroStrip.propTypes = {
  authData: PropTypes.object.isRequired,
  inicio: PropTypes.number,
  fim: PropTypes.number,
  lentes: PropTypes.arrayOf(PropTypes.object),
  heroResumos: PropTypes.object,
  loading: PropTypes.bool,
  onExport: PropTypes.func,
};

HeroStrip.defaultProps = {
  inicio: null,
  fim: null,
  lentes: [],
  heroResumos: {},
  loading: false,
  onExport: undefined,
};

export default HeroStrip;
